import {
  faCheck,
  faXmark,
  faXmarkCircle,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";

function CustomModal({ show, onClose, onConfirm, bodyContent }) {
  if (!show) return null;
  return (
    <div
      className="position-fixed d-flex justify-content-center align-items-center z-2 top-0 bottom-0 start-0 end-0"
      style={{ backgroundColor: "#000000BF" }}
    >
      <div className="bg-light rounded rounded-lg p-5 position-relative">
        <div className="position-absolute end-0 top-0 p-2">
          <FontAwesomeIcon
            icon={faXmarkCircle}
            size="lg"
            onClick={onClose}
            style={{ cursor: "pointer" }}
          />
        </div>
        <div>{bodyContent}</div>
        <div className="d-flex justify-content-end mt-4">
          {onClose && (
            <button
              className="btn me-2 btn-md rounded-lg bg-danger text-light fw-bold px-3 py-1"
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faXmark} /> ரத்து செய்
            </button>
          )}
          {onConfirm && (
            <button
              className="btn btn-md rounded-lg bg-success text-light fw-bold px-3 py-1"
              onClick={onConfirm}
            >
              <FontAwesomeIcon icon={faCheck} /> உறுதி
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

export default CustomModal;
